import React, { PropsWithChildren } from 'react';

// Libraries
import { Link } from 'react-router-dom';

type Props = {
  ariaLabel?: string;
  className?: string;
  route: string;
  value: string;
  onClick?: (value: any) => void;
};

const ControlLinkItem: React.FC<PropsWithChildren<Props>> = ({ ariaLabel, children, className, route, value, onClick, ...rest }) => {
  const clickHandler = () => onClick && onClick(value);

  return (
    <li>
      <Link aria-label={ariaLabel} className={className} to={route} onClick={clickHandler}>
        {children}
      </Link>
    </li>
  );
};

export default ControlLinkItem;
